import { PropsWithChildren } from "react"
import { Article } from "@tm/models"
import { useArticlesContext } from "@bundles/parts/components/ListV2/ContextProvider"
import { ArticlesContext } from "@bundles/parts/components/ListV2/ContextProvider/Articles"
import { BaseArticleData } from "@bundles/parts/components/ListV2/models"
import { useArticles } from "./useArticles"
import { TraderArticle } from "../../../../helpers"

type CarouselArticleProps = {
    parts: (Article | TraderArticle)[]
}

export function CarouselArticlesProvider(props: PropsWithChildren<CarouselArticleProps>) {
    const { parts, children } = props

    const articlesData = useArticles(parts)

    return <ArticlesContext.Provider value={articlesData}>{children}</ArticlesContext.Provider>
}

export function useCarouselArticlesContext<TContext extends BaseArticleData>(): TContext
export function useCarouselArticlesContext<TContext extends BaseArticleData, TReturnType>(selector: (value: TContext) => TReturnType): TReturnType
export function useCarouselArticlesContext<TContext extends BaseArticleData, TReturnType>(
    selector?: (value: TContext) => TReturnType
): TReturnType | TContext {
    return useArticlesContext(selector as never)
}
